// extracted by mini-css-extract-plugin
export default {"App":"App_App__B2Ebb","AppHeader":"App_AppHeader__qxGqX","spinnerContainer":"App_spinnerContainer__aHs9o","AppLink":"App_AppLink__G49XM"};